import { useEffect, useState } from 'react';
import { Card, Table, Pagination } from 'react-bootstrap';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ColorsList() {
    const [colors, setColors] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    useEffect(() => {
        fetchColors();
    }, [currentPage]);

    const fetchColors = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/colors?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setColors(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading colors');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this color?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/colors/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Color deleted successfully');
            fetchColors();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error deleting color');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Colors List' righttitle='Add Color' link='/accounts/colors-add' routebutton={true} permission='colors.create' />
                
                <Card className="mb-3">
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {colors.map((color) => (
                                    <tr key={color.id}>
                                        <td>#{color.id}</td>
                                        <td>{color.name}</td>
                                        <td>
                                            <span className={`badge ${color.is_active ? 'bg-success' : 'bg-warning'}`}>
                                                {color.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/colors-edit/${color.id}`}
                                                    permission="colors.edit"
                                                />
                                                <DeleteButton
                                                    permission="colors.delete"
                                                    onDelete={() => handleDelete(color.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ColorsList;